class CAStates {
    getProvincesList(){
        return  [
            { caption:'Alberta', value:'AB' },
            { caption:'British Columbia', value:'BC' },
            { caption:'Manitoba', value:'MB' },
            { caption:'New Brunswick', value:'NB' },
            { caption:'Newfoundland', value:'NL' },
            { caption:'Northwest Territories', value:'NT' },
            { caption:'Nova Scotia', value:'NS' },
            { caption:'Nunavut', value:'NU' },
            { caption:'Ontario', value:'ON' },
            { caption:'Prince Edward Island', value:'PE' },
            { caption:'Quebec', value:'QC' },
            { caption:'Saskatchewan', value:'SK' },
            { caption:'Yukon Territory', value:'YT' }
        ];
    }
}

// A singleton. Exports instance, not the class.
const states = new CAStates;
export default states;

